import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ListGroup, Badge, Container, Row, Col, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getCurrencySymbol } from "../../common_components/choices";

const ProductOffersLatest = ({ width, height }) => {
    const [productOffers, setProductOffers] = useState([]);

    const pageSize = 3; // Number of offers to fetch per page

    const fetchProductOffers = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/grocery-product-offers/`, {
                headers: { Authorization: `Token ${token}` },
                params: {
                    page_size: pageSize,
                    offer_status: 'ACTIVE',
                    fav_products: true,
                    fav_stores: true
                },
            });
            setProductOffers(response.data.results);
        } catch (error) {
            console.error('Error fetching active products that are part of offers:', error);
        }
    };

    useEffect(() => {
        fetchProductOffers();
    }, []);

    return (
        <Container style={{ width: width, height: height }}>
            <Row>
                <Col>
                    <h6 className="pt-0">Products on Offer</h6>
                    {productOffers.length > 0 ? (
                        <ListGroup variant="flush">
                            {productOffers.map((product) => {
                                // Get the count of offers
                                const offerCount = product.offers.length;

                                // Get the lowest price across all offers
                                const lowestPrice = Math.min(...product.offers.map(offer =>
                                    Math.min(...offer.offer_price_details.map(priceDetail => priceDetail.price))
                                ));

                                return (
                                    <ListGroup.Item
                                        key={product.id}
                                        className="d-flex justify-content-between align-items-center py-1"
                                        style={{ paddingLeft: '0px' }}>
                                        <div>
                                            <Badge bg="info" className="small">{product.brand.name}</Badge>
                                            <strong className="small" style={{ marginLeft: '8px' }}>{product.name}</strong> | <span className="small">{offerCount} offers</span>
                                        </div>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id={`tooltip-lowest-price-${product.id}`}>
                                                    Lowest available price from all active offers.
                                                </Tooltip>
                                            }
                                        >
                                            <span className="small">
                                                {getCurrencySymbol(product.offers[0].offer_price_details[0].currency)} {lowestPrice.toFixed(2)}
                                            </span>
                                        </OverlayTrigger>
                                    </ListGroup.Item>
                                );
                            })}
                        </ListGroup>
                    ) : (
                        <Alert>No upcoming offers on your favorite products from your favorite stores.</Alert>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default ProductOffersLatest;
